/* eslint-disable */
import {
  UilBag,
  UilBuilding,
  UilCreateDashboard,
  UilUsersAlt,
  UilConstructor,
  UilParagraph,
  UilWrench,
  UilUserMd,
  UilMoneybag,
  UilServerNetwork
} from '@iconscout/react-unicons';
import { Col, Menu, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';
import { NavTitle } from './Style';
import { AppRoutes } from '../routes/routes';

function MenuItems({ toggleCollapsed, collapsed }) {
  const { t } = useTranslation();
  const location = useLocation();
  const role_id = useSelector((store) => store.auth.loginData?.role_id ?? 0);

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  const [openKeys, setOpenKeys] = React.useState(location.pathname.includes('job') ? ['jobs'] : [],);
  const [selectedKeys, setSelectedKeys] = React.useState([location.pathname]);

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const allItems = [
    // 0
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.dashboard}>
        {"DASHBOARD"}
      </NavLink>,
      AppRoutes.dashboard,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.dashboard}>
          <UilCreateDashboard />
        </NavLink>
      ),
    ),
    // 1
    getItem(t('jobs'), 'jobs', !topMenu && <UilBag />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${AppRoutes.liveJobs}/query?page=1&size=100`}>
          {t('LIVE JOBS')}
        </NavLink>,
        AppRoutes.liveJobs,
        null,
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={AppRoutes.alarmedJobs}>
          {t('ALARMS')}
        </NavLink>,
        AppRoutes.alarmedJobs,
        null,
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={AppRoutes.orderConfirmedJobs}>
          {'ORDERS CONFIRMED'}
        </NavLink>,
        AppRoutes.orderConfirmedJobs,
        null,
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={AppRoutes.jobCompleted}>
          {t('JOBS COMPLETED')}
        </NavLink>,
        AppRoutes.jobCompleted,
        null,
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={AppRoutes.vdrCOC}>
          {'VDR COC'}
        </NavLink>,
        AppRoutes.vdrCOC,
        null,
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={AppRoutes.invoiceSent}>
          {'INVOICE SENT'}
        </NavLink>,
        AppRoutes.invoiceSent,
        null,
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={AppRoutes.cancelledJobs}>
          {'CANCELLED JOBS'}
        </NavLink>,
        AppRoutes.cancelledJobs,
        null,
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={AppRoutes.jobHistory}>
          {t('JOBS HISTORY')}
        </NavLink>,
        AppRoutes.jobHistory,
        null,
      )
    ]),
    // 2
    getItem(
      !topMenu && (
        <NavTitle className="flex text-[12px] font-medium uppercase text-light mt-[20px] dark:text-white87 p-0">
          {"USERS"}
        </NavTitle>
      ),
      'app-title',
      null,
      null,
      'group',
    ),
    // 3
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.admins}>
        {"Admins"}
      </NavLink>,
      AppRoutes.admins,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.admins}>
          <UilUserMd />
        </NavLink>
      ),
    ),
    // 4
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.jobPublishers}>
        {"JOB PUBLISHERS"}
      </NavLink>,
      AppRoutes.jobPublishers,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.jobPublishers}>
          <UilUsersAlt />
        </NavLink>
      ),
    ),
    // 5
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.engineers}>
        {'ENGINEERS'}
      </NavLink>,
      AppRoutes.engineers,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.engineers}>
          <UilConstructor />
        </NavLink>
      ),
    ),
    // 6
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.accountant}>
        {t('ACCOUNTANTS')}
      </NavLink>,
      AppRoutes.accountant,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.accountant}>
          <UilMoneybag />
        </NavLink>
      ),
    ),
    // 7
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.logistics}>
        {"Logistics"}
      </NavLink>,
      AppRoutes.logistics,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.logistics}>
          <UilUserMd />
        </NavLink>
      ),
    ),
    // 8
    getItem(
      !topMenu && (
        <NavTitle className="flex text-[12px] font-medium uppercase text-light mt-[20px] dark:text-white87 p-0">
          {t('Master')}
        </NavTitle>
      ),
      'group-title',
      null,
      null,
      'group',
    ),
    // 9
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.companies}>
        {t('companies')}
      </NavLink>,
      AppRoutes.companies,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.companies}>
          <UilBuilding />
        </NavLink>
      ),
    ),
    // 10
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.jobDescriptions}>
        {t('job descriptions')}
      </NavLink>,
      AppRoutes.jobDescriptions,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.jobDescriptions}>
          <UilParagraph />
        </NavLink>
      ),
    ),
    // 11
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.spares}>
        {t('spares')}
      </NavLink>,
      AppRoutes.spares,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.spares}>
          <UilWrench />
        </NavLink>
      ),
    ),
    // 12
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.agents}>
        {t('agents')}
      </NavLink>,
      AppRoutes.agents,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.agents}>
          <UilUserMd />
        </NavLink>
      ),
    ),
    // 13
    getItem(
      <NavLink onClick={toggleCollapsed} to={AppRoutes.country}>
        {t('countries')}
      </NavLink>,
      AppRoutes.country,
      !topMenu && (
        <NavLink className="menuItem-iocn" to={AppRoutes.country}>
          <UilServerNetwork />
        </NavLink>
      ),
    ),
  ];

  let items = [];

  switch (role_id) {
    case 5:
      items = allItems
      break;

    case 1:
      items = [allItems[0], allItems[1], allItems[2], allItems[4], allItems[5], allItems[6], allItems[7], allItems[8], allItems[9], allItems[10], allItems[11], allItems[12],  allItems[13]]
      break;

    case 2:
      items = [
        allItems[0],
        getItem("JOBS", 'JOBS', !topMenu && <UilBag />, [
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.liveJobs}>
              {t('LIVE JOBS')}
            </NavLink>,
            AppRoutes.liveJobs,
            null,
          ),
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.alarmedJobs}>
              {t('ALARMS')}
            </NavLink>,
            AppRoutes.alarmedJobs,
            null,
          ),
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.orderConfirmedJobs}>
              {'ORDERS CONFIRMED'}
            </NavLink>,
            AppRoutes.orderConfirmedJobs,
            null,
          ),
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.jobCompleted}>
              {t('JOBS COMPLETED')}
            </NavLink>,
            AppRoutes.jobCompleted,
            null,
          ),
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.vdrCOC}>
              {'VDR COC'}
            </NavLink>,
            AppRoutes.vdrCOC,
            null,
          ),
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.cancelledJobs}>
              {'CANCELLED JOBS'}
            </NavLink>,
            AppRoutes.cancelledJobs,
            null,
          ),
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.jobHistory}>
              {t('JOBS HISTORY')}
            </NavLink>,
            AppRoutes.jobHistory,
            null,
          )
        ]),
      ]
      break

    case 3:
      items = [
        getItem("JOBS", 'JOBS', !topMenu && <UilBag />, [
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.orderConfirmedJobs}>
              {t('ORDERS CONFIRMED')}
            </NavLink>,
            AppRoutes.orderConfirmedJobs,
            null,
          )
        ]),
      ]
      break;

    case 4:
      items = [
        getItem("JOBS", 'JOBS', !topMenu && <UilBag />, [
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.orderConfirmedJobs}>
              {t('ORDERS CONFIRMED')}
            </NavLink>,
            AppRoutes.orderConfirmedJobs,
            null,
          ),
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.jobCompleted}>
              {t('JOBS COMPLETED')}
            </NavLink>,
            AppRoutes.jobCompleted,
            null,
          ),
          getItem(
            <NavLink onClick={toggleCollapsed} to={AppRoutes.invoiceSent}>
              {'INVOICE SENT'}
            </NavLink>,
            AppRoutes.invoiceSent,
            null,
          ),
        ]),
      ]
      break;

      case 6:
        items = [
          getItem("JOBS", 'JOBS', !topMenu && <UilBag />, [
            getItem(
              <NavLink onClick={toggleCollapsed} to={AppRoutes.logisticJobs}>
                {'LOGISTICS'}
              </NavLink>,
              AppRoutes.logisticJobs,
              null,
            ),
            getItem(
              <NavLink onClick={toggleCollapsed} to={AppRoutes.spareVerified}>
                {'PREPARE SPARE'}
              </NavLink>,
              AppRoutes.spareVerified,
              null,
            ),
            getItem(
              <NavLink onClick={toggleCollapsed} to={AppRoutes.sparePrepare}>
                {'SPARE PREPARED'}
              </NavLink>,
              AppRoutes.sparePrepare,
              null,
            ),
          ]),
        ]
      break;

    default:
      break;
  }

  React.useEffect(() => {
    if (!collapsed) {
      setOpenKeys(location.pathname.includes('job') ? ['jobs'] : []);
      setSelectedKeys(location.pathname.includes('liveJob') ? [AppRoutes.liveJobs] : [location.pathname]);
    }
  }, [location])

  return (<>
    <Menu
      onOpenChange={onOpenChange}
      mode="inline"
      selectedKeys={selectedKeys}
      onSelect={({ selectedKeys }) => setSelectedKeys(selectedKeys)}
      defaultSelectedKeys={[location.pathname]}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
    {false && <Row className=' absolute bottom-0 left-0 pl-5'>
      <Col span={24}>
        <span className="inline-block w-full font-medium admin-footer__copyright md:text-center text-theme-gray dark:text-white60 md:mb-[10px]">
          © 2023
          <Link className="mx-[4px] text-primary" to="https://www.thawemarine.com/">
            Thawemarine
          </Link>
        </span>
      </Col>
    </Row>}
  </>
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
  collapsed: propTypes.bool
};

export default MenuItems;
